import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import {
	ISimpleAutoCompleteSearchFieldItemSelectionEvent,
	SimpleAutoCompleteSearchField,
} from '../../../autocomplete/SimpleAutoCompleteSearchField';
import { styleSheet } from '../../../dataBoards/SearchComponent/styles';
import { SearchIcon } from '../../../svgs/icons/SearchIcon';

interface IProps {
	className?: string;
	onClear: () => void;
	onTagSelected: (tag: Api.IAccountTag) => void;
	selectedTag: Api.IAccountTag | null;
	inputStyle?: any;
	placeholder?: string;
}

export const DonationTagSearch = ({
	className,
	onClear,
	onTagSelected,
	selectedTag,
	inputStyle,
	placeholder = 'Search',
}: IProps) => {
	const userSession = useUserSession();
	const [searchValue, setSearchValue] = React.useState('');
	const searchFieldRef = React.useRef<{ setSearchQuery: (query: string) => void } | null>(null);

	const handleItemSelected = (e: ISimpleAutoCompleteSearchFieldItemSelectionEvent) => {
		if (e.selection) {
			// Type assertion is safe here because we know the autocomplete type is AccountTag
			const tag = e.selection as Api.IAccountTag;
			onTagSelected(tag);
			setSearchValue(tag.name);
			if (e.target) {
				e.target.setSearchQuery(tag.name);
			}
		}
	};

	const handleClear = () => {
		setSearchValue('');
		if (searchFieldRef.current) {
			searchFieldRef.current.setSearchQuery('');
		}
		onClear();
	};

	React.useEffect(() => {
		if (selectedTag) {
			setSearchValue(selectedTag.name);
			if (searchFieldRef.current) {
				searchFieldRef.current.setSearchQuery(selectedTag.name);
			}
		} else {
			setSearchValue('');
			if (searchFieldRef.current) {
				searchFieldRef.current.setSearchQuery('');
			}
		}
	}, [selectedTag]);

	return (
		<SimpleAutoCompleteSearchField
			id='donation-tag-search'
			onItemSelected={handleItemSelected}
			onClear={handleClear}
			placeholder={placeholder}
			initialSearchQuery={searchValue}
			onSearchFieldRef={ref => {
				searchFieldRef.current = ref as any;
			}}
			type={Api.ResourceAutoCompleteViewModelType.AccountTag}
			// userSession is required by AutoCompleteSearchField but not properly typed in SimpleAutoCompleteSearchField's interface
			{...({ userSession } as any)}
			leftAccessory={<SearchIcon className={css(styleSheet.searchIcon)} />}
			style={inputStyle || className}
		/>
	);
};
